import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import AssignCallAuditorDialog, {
  AssignCallAuditorUniqueProps,
} from '../assignCallAuditorDialog';

const { useDialogForContext, useDialog: useAssignCallAuditorDialog } =
  getDialogHooks<AssignCallAuditorUniqueProps, boolean>(
    AssignCallAuditorDialog
  );
export const useAssignCallAuditorDialogForContext = useDialogForContext;
export default useAssignCallAuditorDialog;
